var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg7Kw(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 251,
    viewBox: "0 0 251 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.2444 33.707V181.717L131.824 220.897V72.887L64.2444 33.707ZM124.054 129.517L71.2744 99.0369V55.5068L124.054 85.9771V129.517Z",
    fill: "#B2E8C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M154.714 59.8469L87.1244 20.667L64.2344 33.7271L131.814 72.907L154.704 59.8469H154.714Z",
    fill: "#72D09A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M154.714 59.8472C147.094 64.1972 139.445 68.5523 131.825 72.9023L131.824 220.912L154.214 207.857L154.714 59.8472Z",
    fill: "#29A063"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M210.254 207.082L222.544 199.982L224.974 201.442L212.684 208.542L210.254 207.082Z",
    fill: "#B2E8C5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M202.114 202.512L214.414 195.422L216.844 196.872L204.544 203.972L202.114 202.512Z",
    fill: "#29A063"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M208.264 212.152L197.514 205.962L197.464 212.122L208.214 218.323L208.264 212.152Z",
    fill: "#72D09A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7543 134.652L86.8442 152.432L95.5443 157.532L95.0342 174.212L106.474 157.212C103.464 155.382 100.434 153.582 97.4243 151.762C97.5243 146.032 97.6443 140.342 97.7443 134.652H97.7543Z",
    fill: "#F97E73"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M186.544 221.612C172.744 213.622 158.954 205.622 145.154 197.632L139.794 200.732C153.584 208.752 167.384 216.762 181.174 224.782C182.964 223.722 184.754 222.672 186.544 221.612Z",
    fill: "#29A063"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M218.044 205.442L224.974 201.442V205.772L221.744 207.582L218.044 205.442Z",
    fill: "#29A063"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M209.904 200.872L216.844 196.882V201.202L213.604 203.012L209.904 200.872Z",
    fill: "#B2E8C5"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M181.174 224.782C167.384 216.762 153.584 208.752 139.794 200.732V206.912C153.584 214.932 167.384 222.962 181.174 230.982V224.782Z",
    fill: "#72D09A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M207.984 203.042L181.174 218.522V224.782C189.444 220.132 197.704 215.482 205.974 210.842C206.644 208.242 207.324 205.642 207.994 203.042H207.984Z",
    fill: "#29A063"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M202.884 196.682L197.524 205.962L208.244 212.152L224.324 209.062L202.874 196.682H202.884Z",
    fill: "#29A063"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M224.324 209.062L208.244 212.152L208.194 218.323L224.274 215.222L224.324 209.062Z",
    fill: "#B2E8C5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M205.964 210.842C197.694 215.492 189.434 220.142 181.164 224.782V230.982L205.964 216.512C205.964 214.622 205.964 212.732 205.964 210.842Z",
    fill: "#B2E8C5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M205.964 210.842C197.694 215.492 189.434 220.142 181.164 224.782V230.982C189.414 226.322 197.654 221.652 205.904 216.992C205.924 214.942 205.944 212.892 205.954 210.842H205.964Z",
    fill: "#B2E8C5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M102.165 87.0923C102.165 87.1723 102.125 87.2523 102.145 87.3423C102.165 87.6323 102.085 87.8823 101.945 88.1123C101.165 89.5123 100.395 90.9025 99.6346 92.3025C98.9746 93.5025 98.3046 94.7124 97.6646 95.9224C97.0746 97.0224 96.4546 98.1224 95.8446 99.2324C95.8246 99.2824 95.7946 99.3223 95.7446 99.4023C94.3846 98.5223 93.0246 97.6324 91.6446 96.7324C93.7746 93.1524 95.8946 89.5624 98.0046 85.9724C97.4946 85.6424 96.9946 85.3224 96.4646 84.9824C95.3846 84.2924 94.3146 83.6024 93.2346 82.9224C92.6046 82.5124 91.9546 82.1024 91.3146 81.7024C91.1546 81.5924 91.0946 81.4925 91.1046 81.2825C91.1546 80.1225 91.1746 78.9625 91.2046 77.7925C91.2046 77.7225 91.2046 77.6425 91.2046 77.5425C91.4446 77.6825 91.6346 77.8224 91.8346 77.9524C93.2946 78.8824 94.7446 79.8024 96.2046 80.7424C97.5446 81.6024 98.8946 82.4525 100.225 83.3225C100.875 83.7425 101.535 84.1525 102.185 84.5525C102.185 85.4025 102.165 86.2423 102.145 87.0923H102.165Z",
    fill: "#F97E73"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M180.875 223.712L181.255 223.272L180.875 223.712Z",
    fill: "#29A063"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg7Kw);
export default __webpack_public_path__ + "static/media/7kw.2f7a33ec8f5c841ebc7c43c306a336fd.svg";
export { ForwardRef as ReactComponent };